Selector.View.QuestionTabView = Backbone.View.extend(
/** @lends Selector.View.QuestionView# */
{	
	/** classname to give the generated element */
	className: "e_selector_tab",
	
	/** tagname to give this generated element */
	tagName: "div",
	
	/** template to use for Underscore.js rendering */
	template: _.template($('#selector_tab').html()),

    events: {
        "click a": 	"goToGroup"
    },

	/** Render function */
	render: function() {
		this.$el.html(this.template(this.model.attributes));//render the HTML
		return this; //needed in order to chain rendering
	},

    goToGroup: function(){
	    this.model.activate();
    }

});